import React from 'react'

interface UserAvatarProps {
  firstName: string
  lastName: string
  profileImage?: string | null
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

const sizeClasses = {
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 text-base',
  lg: 'w-16 h-16 text-xl',
  xl: 'w-24 h-24 text-3xl',
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  firstName,
  lastName,
  profileImage,
  className = "",
  size = 'sm'
}) => {
  const getInitials = (first: string, last: string) => {
    return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase()
  }

  const sizeClass = sizeClasses[size]

  if (profileImage) {
    return (
      <div className={`${sizeClass} rounded-full overflow-hidden shadow-sm ${className}`}>
        <img
          src={profileImage}
          alt={`${firstName} ${lastName}`}
          className="w-full h-full object-cover"
        />
      </div>
    )
  }

  return (
    <div className={`${sizeClass} bg-gradient-to-r from-purple-500 to-blue-500 dark:from-purple-400 dark:to-blue-400 rounded-full flex items-center justify-center text-white font-medium shadow-sm ${className}`}>
      {getInitials(firstName, lastName)}
    </div>
  )
}